import { CSSProperties, forwardRef, useState } from 'react';

import Checkmark from 'assets/list-checkmark.svg';
import { Visible } from 'coreOld/components';

import {
  CheckboxContainer,
  HiddenCheckbox,
  Icon,
  Label,
  StyledCheckbox,
} from './checkboxInputStyle';

interface IProps {
  value?: string;
  name?: string;
  defaultChecked?: boolean;
  checked?: boolean;
  disabled?: boolean;
  label?: string;
  id?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  title?: string;
  style?: CSSProperties;
  isLoading?: boolean;
}

const CheckboxInputView = forwardRef(function CheckboxInputView(
  {
    value,
    defaultChecked,
    checked,
    disabled,
    label,
    onChange,
    id,
    title,
    style,
    name,
    isLoading = false,
  }: IProps,
  ref
) {
  const [isChecked, setIsChecked] = useState(defaultChecked || checked);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);

    onChange && onChange(event);
  };

  return (
    <CheckboxContainer disabled={disabled} htmlFor={id} style={style}>
      <HiddenCheckbox
        name={name}
        title={title}
        ref={ref}
        type="checkbox"
        id={id}
        value={value}
        defaultChecked={defaultChecked}
        checked={checked}
        onChange={handleOnChange}
        disabled={disabled || isLoading}
      />

      <StyledCheckbox checked={checked || defaultChecked || isChecked}>
        <Icon src={Checkmark} />
      </StyledCheckbox>

      <Visible when={Boolean(label)}>
        <Label>{label}</Label>
      </Visible>
    </CheckboxContainer>
  );
});

export default CheckboxInputView;
